module.exports = __webpack_public_path__ + "static/media/cool.72df884a.svg";